import { 
  SET_FILTRO_REBATES,
  LOADING_REBATES, 
  FETCH_REBATES, 
  FETCH_REBATE, 
  EDIT_REBATE,
  RESET_REBATES
} from './types';
import { fetchListRebatesApi, fetchRebatesApi } from "../api/axios";

const normalizeRebatesList = (response) => {
  const src = response ?? {};
  const data = src?.data ?? src;

  const content =
    Array.isArray(data?.content) ? data.content :
      Array.isArray(data?.Content) ? data.Content :
        Array.isArray(data?.elementos) ? data.elementos :
          Array.isArray(data?.Elementos) ? data.Elementos :
            Array.isArray(data?.rebatesResponse?.content) ? data.rebatesResponse.content :
              Array.isArray(data?.RebatesResponse?.Content) ? data.RebatesResponse.Content :
            Array.isArray(data?.rebates) ? data.rebates :
            Array.isArray(data?.rebates?.content) ? data.rebates.content :
              Array.isArray(data?.rebates?.Content) ? data.rebates.Content :
                Array.isArray(data?.data) ? data.data : [];

  const total =
    data?.total ?? data?.Total ??
    data?.cantidadTotal ?? data?.CantidadTotal ??
    data?.rebatesResponse?.total ?? data?.rebatesResponse?.Total ??
    data?.rebates?.total ?? data?.rebates?.Total ??
    content.length;

  const normalizeEstado = (estadoRaw) => {
    const raw = typeof estadoRaw === 'string'
      ? estadoRaw
      : (estadoRaw?.descripcion ?? estadoRaw?.Descripcion ?? estadoRaw?.estado ?? estadoRaw?.Estado ?? estadoRaw);
    if (raw == null) return null;
    if (typeof raw === 'number') {
      if (raw === 1) return "Pendiente";
      if (raw === 2) return "En revision";
      if (raw === 3) return "Activo";
      if (raw === 4) return "Finalizado";
      if (raw === 5 || raw === 6) return "Rechazado";
      return null;
    }
    const normalized = String(raw).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    if (normalized.includes("activo")) return "Activo";
    if (normalized.includes("revision")) return "En revision";
    if (normalized.includes("pendiente")) return "Pendiente";
    if (normalized.includes("finalizado") || normalized.includes("eliminado")) return "Finalizado";
    if (normalized.includes("rechaz")) return "Rechazado";
    return String(raw);
  };

  const normalizeItem = (item) => {
    const dataRebateRaw = item?.dataRebate ?? item?.DataRebate ?? item?.rebate ?? item?.Rebate ?? item ?? {};
    const porcentajesRaw = item?.porcentajesRebate ?? item?.PorcentajesRebate ?? item?.porcentajes ?? item?.Porcentajes ?? {};
    const tipoPublicacionRaw = item?.tipoPublicacion ?? item?.TipoPublicacion ?? {};
    const imagenesRaw = Array.isArray(item?.imagenes) ? item.imagenes : (Array.isArray(item?.Imagenes) ? item.Imagenes : []);

    return {
      ...item,
      titulo: item?.titulo ?? item?.Titulo ?? "",
      descripcionSeller: item?.descripcionSeller ?? item?.DescripcionSeller ?? item?.seller ?? item?.Seller ?? "",
      skuSeller: item?.skuSeller ?? item?.SkuSeller ?? "",
      skuMarket: item?.skuMarket ?? item?.SkuMarket ?? "",
      estadoRebate: normalizeEstado(item?.estadoRebate ?? item?.EstadoRebate),
      dataRebate: {
        id: dataRebateRaw?.id ?? dataRebateRaw?.Id ?? 0,
        idPublicacion: dataRebateRaw?.idPublicacion ?? dataRebateRaw?.IdPublicacion ?? 0,
        precioInicial: dataRebateRaw?.precioInicial ?? dataRebateRaw?.PrecioInicial ?? 0,
        precioFinal: dataRebateRaw?.precioFinal ?? dataRebateRaw?.PrecioFinal ?? 0,
        aCargoMegatone: dataRebateRaw?.aCargoMegatone ?? dataRebateRaw?.ACargoMegatone ?? 0,
        aCargoSeller: dataRebateRaw?.aCargoSeller ?? dataRebateRaw?.ACargoSeller ?? 0,
        fechaInicio: dataRebateRaw?.fechaInicio ?? dataRebateRaw?.FechaInicio ?? null,
        fechaVencimiento: dataRebateRaw?.fechaVencimiento ?? dataRebateRaw?.FechaVencimiento ?? null,
        unidades: dataRebateRaw?.unidades ?? dataRebateRaw?.Unidades ?? 0,
        unidadesRestantes: dataRebateRaw?.unidadesRestantes ?? dataRebateRaw?.UnidadesRestantes ?? 0
      },
      porcentajesRebate: {
        porcentajeTotalDescuento: porcentajesRaw?.porcentajeTotalDescuento ?? porcentajesRaw?.PorcentajeTotalDescuento ?? 0,
        porcentajeMegatone: porcentajesRaw?.porcentajeMegatone ?? porcentajesRaw?.PorcentajeMegatone ?? 0,
        porcentajeSeller: porcentajesRaw?.porcentajeSeller ?? porcentajesRaw?.PorcentajeSeller ?? 0
      },
      tipoPublicacion: {
        descripcion: tipoPublicacionRaw?.descripcion ?? tipoPublicacionRaw?.Descripcion ?? ""
      },
      imagenes: imagenesRaw.map((img) => ({
        ...img,
        urlImagen: img?.urlImagen ?? img?.UrlImagen ?? ""
      }))
    };
  };

  return {
    content: content.map(normalizeItem),
    total
  };
};


export const setFiltroRebates = (filtro) => dispatch => {
  
  dispatch({
    type: SET_FILTRO_REBATES,
    payload: filtro
  });

}

export const fetchRebates = (params) => async dispatch => {
  dispatch({
    type: LOADING_REBATES,
    payload: true
  });
  
  const req = fetchListRebatesApi(params);

  req.then((response) => {
    const normalized = normalizeRebatesList(response);

    dispatch({
      type: FETCH_REBATES,
      payload: { rebates: normalized }
    });

    dispatch({
      type: LOADING_REBATES,
      payload: false
    });
  }).catch(() => {
    dispatch({
      type: FETCH_REBATES,
      payload: { rebates: { content: [], total: 0 } }
    });
    dispatch({
      type: LOADING_REBATES,
      payload: false
    });
  })
}

export const fetchRebate = (params) => async dispatch => {
  dispatch({
    type: LOADING_REBATES,
    payload: true
  });

  const req = fetchRebatesApi(params);

  req.then((rebate) => {

    dispatch({
      type: FETCH_REBATE,
      payload: rebate
    });

    dispatch({
      type: LOADING_REBATES,
      payload: false
    });
  })
}

export const editRebate = (rebate) => dispatch => {
  
  dispatch({
    type: EDIT_REBATE,
    payload: rebate
  });
}

export const resetRebates = () => dispatch => {
  
  dispatch({
    type: RESET_REBATES,
    payload: {}
  });
}